import { useMemo } from 'react';
import { set } from 'lodash';
import { isDefined } from '@bbkAdminRedux/rtkq/rtkq-utils';
import { useLocation } from '@bbkShared/react-router';

export const parseSearchParams = <T extends Record<string, unknown>>(
  search?: string
): Partial<T> => {
  const params = new URLSearchParams(search);

  const obj = {} as T;
  params.forEach((val, key) => {
    const objEl = obj[key];
    if (isDefined(objEl)) {
      const objArr = Array.isArray(objEl) ? objEl : [objEl];
      objArr.push(val);
      set(obj, key, objArr);
    } else {
      set(obj, key, val);
    }
  });

  return obj;
};

export const useSearchParams = <
  T extends Record<string, unknown> = {},
>(): Partial<T> => {
  const location = useLocation();

  return useMemo(
    () => parseSearchParams(location.search) as T,
    [location.search]
  );
};
